module.exports = __webpack_public_path__ + "static/img/icon-step5-on.0803a789.png";